<template>
  <div class="servico_bolsas">
    <template v-for="(section,index) in content">
      <div 
        class="row textblock"
        :class="{'block_sem_linha': index == content.length -1}">
          <div class="small-12 medium-2 large-4 columns">
              <img class="img_azoto" :src="section.image">
          </div>
          <div class="small-12 medium-10 large-8 columns textoazoto">
              <h4>{{ section.q }}</h4>
              <p v-html="section.d"></p>
          </div>
      </div>
      <div 
        class="textblock_responsive"
        :class="{'block_sem_linha': index == content.length -1}">
          <div class="row">
              <div class="small-2 medium-2 columns">
                <img class="img_azoto_responsive" :src="section.image">
              </div>
              <div class="small-10 medium-10 columns textoazoto">
                <h4>{{ section.q }}</h4>
              </div>
          </div>
          <div class="row">
            <p v-html="section.d"></p>
          </div>
      </div>
    </template>
  </div>

</template>

<script>
import { i18n } from '@/main.js';
import icons5 from "@/assets/images/uerf-icons-05.png";
import icons6 from "@/assets/images/uerf-icons-06.png";
import icons7 from "@/assets/images/uerf-icons-07.png";
import icons8 from "@/assets/images/uerf-icons-08.png";
import icons9 from "@/assets/images/uerf-icons-09.png";
import icons10 from "@/assets/images/uerf-icons-10.png";

export default {
  setup () {

    const { t } = i18n.global;

    
    const content = [
      { q: t('azoto.UMA_LANG_DSIE_AZOTO_T1'), d: t('azoto.UMA_LANG_DSIE_AZOTO_D1'), image: icons5 },
      { q: t('azoto.UMA_LANG_DSIE_AZOTO_T2'), d: t('azoto.UMA_LANG_DSIE_AZOTO_D2'), image: icons6 },
      { q: t('azoto.UMA_LANG_DSIE_AZOTO_T3'), d: t('azoto.UMA_LANG_DSIE_AZOTO_D3'), image: icons7 },
      { q: t('azoto.UMA_LANG_DSIE_AZOTO_T4'), d: t('azoto.UMA_LANG_DSIE_AZOTO_D4'), image: icons8 },
      { q: t('azoto.UMA_LANG_DSIE_AZOTO_T5'), d: t('azoto.UMA_LANG_DSIE_AZOTO_D5'), image: icons9 },
      { q: t('azoto.UMA_LANG_DSIE_AZOTO_T6'), d: t('azoto.UMA_LANG_DSIE_AZOTO_D6'), image: icons10 },
    ]

    return {
      content
    }
  }
}
</script>

<style lang="scss" scoped>

.servico_bolsas {
  padding-bottom: 100px;
}

.servico_bolsas .columns.textoazoto{
  padding-left: 30px;
}

@media screen and (max-width: 1280px) {
  .servico_bolsas .columns.textoazoto {
    padding-left: 0px;
  }
}

.textblock{
  padding-bottom: 50px;
  padding-top: 50px;
  border-bottom: 1px solid #ccc;
}

.textblock img {
  width: 260px;
  padding-left: 50px;
}

@media screen and (max-width: 1280px) {
  .textblock img {
    width: 200px;
  }
}

.textblock > .columns,
.textblock_responsive .columns{
  padding-left: 0;
  padding-right: 0;
}


.textblock_responsive {
  display: none;
}

.textoazoto h4 {
  font-family: "Montserrat Bold";
  color: #335886;
  font-size: 23px;
  margin-top: 28px;
  margin-bottom: 20px;
  font-size: 22px;
}

.textoazoto p{
  font-size: 16px;
  font-family: "PT Sans";
  line-height: 2;
  color:#7a7a7a;
  padding-right: 40px;
  margin-bottom: 30px;
}

.textoazoto :deep(.dark_fim){
  font-family: "Montserrat Bold";
  color: #636363;
  padding-top: 20px;
  display: block;
}

.textoazoto :deep(.dark){
  font-family: "Montserrat Bold";
  color: #636363;
}

.block_sem_linha {
  border-bottom: transparent;
}


@media (min-width : 768px) and (max-width : 1024px){
  .textblock {
    display: none;
  }
  .textblock_responsive {
    display: block;
  }

  .textblock_responsive p {
    font-size: 16px;
    font-family: "PT Sans";
    line-height: 2;
    color: #7a7a7a;
    padding-right: 0px;
    margin-bottom: 30px;
    margin-left: 20px;
    margin-top: 10px;
  }

  :deep(.dark_fim) {
    font-family: "Montserrat Bold";
    color: #636363;
    padding-top: 13px;
    display: block;
    font-size: 15px;
    line-height: 1.7;
  }

  :deep(.dark) {
    font-family: "Montserrat Bold";
    color: #636363;
  }

  .img_azoto_responsive {
    width: 100px;
  }

  .textoazoto h4 {
    font-size: 19px;
    padding-left: 0px;
    padding-top: 8px;
  }
}

@media screen and (max-width: 767px) {
  
  .img_azoto_responsive {
    width: 80px;
    padding-bottom: 13px;
  }

  .textoazoto h4 {
      font-size: 15px;
      padding-left: 5px;
      padding-top: 2px;
      margin-top: 18px;
      line-height: 1.25;

  }

  .textoazoto {
      margin: auto;
      width: 50%;
  }

  .textblock_responsive {
    display: block;
  }

  .textblock {
    display: none;
  }

  .textoazoto {
    margin: auto;
    width: 50%;
  }

  .textblock_responsive {
    border-bottom: 1px solid #ccc;
    padding-bottom: 10px;
    padding-top: 20px;
  }

  .textblock_responsive p {
    font-size: 14px;
    font-family: "PT Sans";
    line-height: 1.9;
    color: #7a7a7a;
    padding-right: 0px;
    margin-bottom: 30px;
    margin-left: 20px;
  }

  :deep(.dark_fim) {
    font-family: "Montserrat Bold";
    color: #636363;
    padding-top: 13px;
    display: block;
    font-size: 14px;
    line-height: 1.7;
  }

  :deep(.dark){
    font-family: "Montserrat Bold";
    color: #636363;
  }


}

</style>